import { render, staticRenderFns } from "./IconDocumentDuplicateSolid.vue?vue&type=template&id=19f44f9e"
import script from "./IconDocumentDuplicateSolid.vue?vue&type=script&lang=js"
export * from "./IconDocumentDuplicateSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports